import React, { useState, useRef, useEffect } from "react";
import {
  CarouselContainer,
  ImageWrapper,
  Button,
  CarouselTrack,
  Wrapper,
} from "./styles";

const Carousel = ({ images }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const trackRef = useRef(null);

  const nextImage = () => {
    setCurrentIndex((prev) => (prev + 1) % images.length);
  };

  const prevImage = () => {
    setCurrentIndex((prev) => (prev - 1 + images.length) % images.length);
  };

  useEffect(() => {
    const track = trackRef.current;
    if (!track) return;

    let startX = 0;
    let endX = 0;

    const handleTouchStart = (e) => {
      startX = e.touches[0].clientX;
    };

    const handleTouchMove = (e) => {
      endX = e.touches[0].clientX;
    };

    const handleTouchEnd = () => {
      const diff = startX - endX;
      if (diff > 50) nextImage();
      else if (diff < -50) prevImage();
    };

    track.addEventListener("touchstart", handleTouchStart);
    track.addEventListener("touchmove", handleTouchMove);
    track.addEventListener("touchend", handleTouchEnd);

    return () => {
      track.removeEventListener("touchstart", handleTouchStart);
      track.removeEventListener("touchmove", handleTouchMove);
      track.removeEventListener("touchend", handleTouchEnd);
    };
  }, [currentIndex]);

  return (
    <Wrapper>
      <CarouselContainer>
        <Button onClick={prevImage} className="prev">
          ❮
        </Button>
        <CarouselTrack
          ref={trackRef}
          style={{ transform: `translateX(-${currentIndex * 100}%)` }}
        >
          {images.map((src, index) => (
            <ImageWrapper key={index}>
              <img src={src} alt={`img-${index}`} />
            </ImageWrapper>
          ))}
        </CarouselTrack>
        <Button onClick={nextImage} className="next">
          ❯
        </Button>
      </CarouselContainer>
    </Wrapper>
  );
};

export default Carousel;
